import gql from 'graphql-tag';

const getAccountCardPreviewFileQuery = gql`
  query getAccountCardPreviewFileQuery($id: RecordID!) {
    accountCard(id: $id) {
      id
      front_preview_file_url
    }
  }
`;

export default getAccountCardPreviewFileQuery;
